(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
var T13 = {
        brakD:  __pewniaki_inline_cfg[0],
        sr:     __pewniaki_inline_cfg[1],
        srMod:  __pewniaki_inline_cfg[2],
        srBrak: __pewniaki_inline_cfg[3],
        udzial: __pewniaki_inline_cfg[4],
        udzMod: __pewniaki_inline_cfg[5],
        chi:    __pewniaki_inline_cfg[6],
        kryt:   __pewniaki_inline_cfg[7],
        przekr: __pewniaki_inline_cfg[8],
        nieprz: __pewniaki_inline_cfg[9],
        bezKal: __pewniaki_inline_cfg[10],
        testyW: __pewniaki_inline_cfg[11],
        kryt2:  __pewniaki_inline_cfg[12],
        jaPrz:  __pewniaki_inline_cfg[13],
        jejNie: __pewniaki_inline_cfg[14],
        orient: __pewniaki_inline_cfg[15],
        testyW2:__pewniaki_inline_cfg[16],
        brakMod:__pewniaki_inline_cfg[17],
        malo:   __pewniaki_inline_cfg[18]
    };

window.PEWNIAKI_ANALIZA = {
    plik:   '/assets/json/db/' + __pewniaki_inline_cfg[19] + '/analizy/struktura.json',
    wersja: __pewniaki_inline_cfg[20],
    lata:   '/assets/json/db/' + __pewniaki_inline_cfg[21] + '/lata/',
    pula:   JSON.parse(String(__pewniaki_inline_cfg[22])),
    typuje: JSON.parse(String(__pewniaki_inline_cfg[23])),
    kryt:   __pewniaki_inline_cfg[24],
    // Zakres lat: suma SUROWYCH licznikow powtorzen z rocznikow (plan V2 §5.3).
    sumujLata: function (roczniki) {
        var pow = {}, N = 0;
        roczniki.forEach(function (r) {
            N += r.losowan || 0;
            Object.keys(r.powtorzenia || {}).forEach(function (s) { pow[s] = (pow[s] || 0) + r.powtorzenia[s]; });
        });
        return { losowan: N, powtorzenia: pow, testy_powod: null };
    },
    // Ta sama metoda co w Twigu: koszyki az N*p >= 5, ogon do ostatniego zamknietego.
    _licz: function (okno, dane) {
        var A = window.PEWNIAKI_ANALIZA;
        var typuje = (dane && dane.typuje) || A.typuje;
        var mp = dane && dane.model && dane.model.powtorzenia ? dane.model.powtorzenia : null;
        if (mp && !Object.keys(mp).length) { mp = null; }
        var pow = okno.powtorzenia || {}, Nobs = 0, sumaR = 0, zPowt = 0, r, ile;
        for (r = 0; r <= typuje; r++) { ile = pow[r] || 0; Nobs += ile; sumaR += r * ile; if (r > 0) { zPowt += ile; } }
        var w = { N: okno.losowan || 0, Nobs: Nobs, typuje: typuje, pow: pow, mp: mp,
                  srednia: Nobs ? sumaR / Nobs : null, udzial: Nobs ? zPowt * 100 / Nobs : null,
                  mSrednia: null, mUdzial: null, chi: null, df: null, kryt: null,
                  testyPowod: okno.testy_powod || null };
        if (mp) {
            w.mSrednia = 0; w.mUdzial = 0;
            for (r = 0; r <= typuje; r++) { if (mp[r] != null) { w.mSrednia += r * mp[r]; if (r > 0) { w.mUdzial += mp[r] * 100; } } }
        }
        if (mp && Nobs > 0 && !w.testyPowod) {
            var chi = 0, koszyki = 0, bO = 0, bE = 0, oO = null, oE = null;
            for (r = 0; r <= typuje; r++) {
                if (mp[r] == null) { continue; }
                bO += pow[r] || 0; bE += Nobs * mp[r];
                if (bE >= 5) { chi += (bO - bE) * (bO - bE) / bE; koszyki++; oO = bO; oE = bE; bO = 0; bE = 0; }
            }
            if (bE > 0 && oE !== null) { chi -= (oO - oE) * (oO - oE) / oE; oO += bO; oE += bE; chi += (oO - oE) * (oO - oE) / oE; }
            if (koszyki >= 2) { w.chi = chi; w.df = koszyki - 1; w.kryt = A.kryt[w.df] != null ? A.kryt[w.df] : null; }
        }
        return w;
    },
    wnioski: function (okno, klucz, dane) {
        if (!okno) { return [__pewniaki_inline_cfg[25]]; }
        var f = function (v, m) { return v == null ? '—' : v.toFixed(m).replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','); };
        var w = window.PEWNIAKI_ANALIZA._licz(okno, dane), p = [];
        if (w.srednia != null) {
            p.push(T13.sr.replace('%1', w.N).replace('%2', w.Nobs).replace('%3', f(w.srednia, 2))
                 + (w.mSrednia != null ? T13.srMod.replace('%1', f(w.mSrednia, 2)) : T13.srBrak));
        }
        if (w.udzial != null) {
            p.push(T13.udzial.replace('%1', f(w.udzial, 1)) + (w.mUdzial != null ? T13.udzMod.replace('%1', f(w.mUdzial, 1)) : '.'));
        }
        if (w.chi != null) {
            p.push(T13.chi.replace('%1', f(w.chi, 2)).replace('%2', w.df) + (w.kryt != null
                 ? T13.kryt.replace('%1', f(w.kryt, 2)).replace('%2', w.chi > w.kryt ? T13.przekr : T13.nieprz)
                 : T13.bezKal));
        } else if (w.testyPowod) {
            p.push(T13.testyW.replace('%1', String(w.testyPowod).replace(/_/g, ' ')));
        }
        return p.length ? p : [__pewniaki_inline_cfg[26]];
    },
    render: function (okno, klucz, dane) {
        var q = function (s) { return document.querySelector(s); };
        var tys = function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
        var f = function (v, m) { return v == null ? '—' : v.toFixed(m).replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','); };
        var sekcja = q('[data-powtorzenia-model]');
        if (!okno) { if (sekcja) { sekcja.hidden = true; } return; }
        if (sekcja) { sekcja.hidden = false; }
        var w = window.PEWNIAKI_ANALIZA._licz(okno, dane);
        q('[data-powtorzenia-model-n]').textContent = tys(w.N);
        q('[data-powtorzenia-model-nobs]').textContent = tys(w.Nobs);
        q('[data-powtorzenia-model-srednia]').textContent = f(w.srednia, 2);
        q('[data-powtorzenia-model-m-srednia]').textContent = f(w.mSrednia, 2);
        q('[data-powtorzenia-model-udzial]').textContent = w.udzial == null ? '—' : f(w.udzial, 1) + '%';
        q('[data-powtorzenia-model-m-udzial]').textContent = w.mUdzial == null ? '—' : f(w.mUdzial, 1) + '%';
        q('[data-powtorzenia-model-chi]').textContent = f(w.chi, 2);
        q('[data-powtorzenia-model-df]').textContent = w.df == null ? '—' : w.df;
        q('[data-powtorzenia-model-kryt]').textContent = f(w.kryt, 2);
        var wiersze = [];
        if (!w.Nobs) {
            wiersze.push(__pewniaki_inline_cfg[27]);
        } else {
            for (var r = 0; r <= w.typuje; r++) {
                var ile = w.pow[r] || 0, p = w.mp && w.mp[r] != null ? w.mp[r] : null;
                if (!(ile > 0 || (p != null && w.Nobs * p >= 0.05))) { continue; }
                wiersze.push('<tr><td class="liczbowa">' + r + '</td><td class="liczbowa">' + tys(ile) + '</td><td class="liczbowa">'
                    + f(ile * 100 / w.Nobs, 1) + '%</td><td class="liczbowa">' + (p != null ? f(w.Nobs * p, 1) : '—') + '</td><td class="liczbowa">'
                    + (p != null ? f(p * 100, 1) + '%' : '—') + '</td></tr>');
            }
        }
        q('[data-powtorzenia-model-tabela] tbody').innerHTML = wiersze.join('');
        q('[data-powtorzenia-model-test-zdanie]').textContent = w.chi != null
            ? T13.chi.replace('%1', f(w.chi, 2)).replace('%2', w.df) + (w.kryt != null ? T13.kryt2.replace('%1', f(w.kryt, 2)).replace('%2', w.chi > w.kryt ? T13.jaPrz : T13.jejNie) : '') + T13.orient
            : (w.testyPowod ? T13.testyW2.replace('%1', String(w.testyPowod).replace(/_/g, ' '))
            : (!w.mp ? T13.brakMod
            : T13.malo));
    }
};
})();
